export const  traduccionGrid = {
    
        page: "página",
        more: "más",
        to: "a",
        of: "de",
        next: "próxima",
        last: "última",
        first: "primera",
        previous: "anterio",
        loadingOoo: "Nada que mostras...",
        selectAll: "seleccionar todo",
        searchOoo: "buscar...",
        blanks: "daBlanc",
        filterOoo: "filtrar...",
        applyFilter: "aplicar filtros...",
        equals: "Igual",
        notEqual: "Distinto de",
        notContains: "no contiene",
        
        lessThanOrEqual: "menor o igual",
        greaterThanOrEqual: "mayor o igual",
        inRange: "en el rango",
        lessThan: "menor que",
        greaterThan: "mayor que",
        contains: "Contiene",
        
        startsWith: "comienza con",
        endsWith: "acaba en",
        group: "grupo",
        columns: "columnas",
        rowGroupColumns: "agrupar columnas",
        rowGroupColumnsEmptyMessage: "por favor arrastra la columna para agrupar",
        valueColumns: "valor de las columnas",
        pivotMode: "pivote",
        groups: "grupos",
        values: "valores",
        pivots: "pivotes",
        valueColumnsEmptyMessage: "drag cols to aggregate",
        pivotColumnsEmptyMessage: "drag here to pivot",
        noRowsToShow: "sin resultados",
        pinColumn: "fijar columna",
        valueAggregation: "Value Agg",
        autosizeThiscolumn: "Autosize Diz",
        autosizeAllColumns: "Autsoie em All",
        groupBy: "agrupar por",
        ungroupBy: "deasagrupar",
        resetColumns: "resetear columna",
        expandAll: "expandir todo",
        collapseAll: "colapsar todo",
        toolPanel: "Tool Panel",
        export: "Exportar",
        csvExport: "la CSV Exportp",
        excelExport: "la Excel Exporto",
        pinLeft: "laPin <<",
        pinRight: "laPin >>",
        noPin: "laDontPin <>",
        sum: "laSum",
        min: "laMin",
        max: "laMax",      
        none: "ninguno",
        count: "contar",
        average: "media",
        copy: "copiar",
        ctrlC: "ctrl n C",
        paste: "pegar",
        ctrlV: "ctrl n C"
    
}
export const  traduccionGridGallego= {
    
        page: "páxina",
        more: "más",
        to: "a",
        of: "de",
        next: "próxima",
        last: "última",
        first: "primera",
        previous: "anterio",
        loadingOoo: "Nada que mostras...",
        selectAll: "seleccionar todo",
        searchOoo: "buscar...",
        blanks: "daBlanc",
        filterOoo: "filtrar...",
        applyFilter: "aplicar filtros...",
        equals: "Igual",
        notEqual: "Distinto de",
        notContains: "no contiene",
        
        lessThanOrEqual: "menor o igual",
        greaterThanOrEqual: "mayor o igual",
        inRange: "en el rango",
        lessThan: "menor que",
        greaterThan: "mayor que",
        contains: "Contiene",
        
        startsWith: "comienza con",
        endsWith: "acaba en",
        group: "grupo",
        columns: "columnas",
        rowGroupColumns: "agrupar columnas",
        rowGroupColumnsEmptyMessage: "por favor arrastra la columna para agrupar",
        valueColumns: "valor de las columnas",
        pivotMode: "pivote",
        groups: "grupos",
        values: "valores",
        pivots: "pivotes",
        valueColumnsEmptyMessage: "drag cols to aggregate",
        pivotColumnsEmptyMessage: "drag here to pivot",
        noRowsToShow: "sen resultados",
        pinColumn: "fijar columna",
        valueAggregation: "Value Agg",
        autosizeThiscolumn: "Autosize Diz",
        autosizeAllColumns: "Autsoie em All",
        groupBy: "agrupar por",
        ungroupBy: "deasagrupar",
        resetColumns: "resetear columna",
        expandAll: "expandir todo",
        collapseAll: "colapsar todo",
        toolPanel: "Tool Panel",
        export: "Exportar",
        csvExport: "la CSV Exportp",
        excelExport: "la Excel Exporto",
        pinLeft: "laPin <<",
        pinRight: "laPin >>",
        noPin: "laDontPin <>",
        sum: "laSum",
        min: "laMin",
        max: "laMax",      
        none: "ninguno",
        count: "contar",
        average: "media",
        copy: "copiar",
        ctrlC: "ctrl n C",
        paste: "pegar",
        ctrlV: "ctrl n C"
    
}